import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator, Linking, Image, Text
} from "react-native";

import {scale, moderateScale, verticalScale} from '../../../../tools/Scaling';

import Colors from "../../../../tools/Colors";


const {width: SCREEN_WIDTH} = Dimensions.get("window");

const SLIDER_HEIGHT = verticalScale(180);
const HEADER_HEIGHT = Platform.OS === "ios" ? verticalScale(64) : verticalScale(50);
const SCROLL_HEIGHT = SLIDER_HEIGHT - HEADER_HEIGHT;
const THEME_COLOR = Colors.colorPrimary;


import HMTextView from "../../../../customviews/HMTextView";
import HMActionBar from "../../../../customviews/HMActionBarSatia";
import i18n from "../../../../I18n/i18n";
import HMImageView from "../../../../customviews/HMImageView";
import PathFile from "../../../../assets/PathFile";
import {typeExport} from "../../../../redux/store/type";
import Hyperlink from "../../../../customviews/Hyperlink";

const IS_ANDROID = Platform.OS === 'android';
const SLIDER_1_FIRST_ITEM = 1;
let container = null;


export default class HelpSoftwareSatiaScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === "web" ? 1 : typeExport._WIDTH;

        if (Platform.OS === "web") {
            let viewportWidth = document.body.clientWidth;
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;


            sliderWidth = viewportWidth;
        }

        this.state = {
            widthOriginal: widthOriginal,

            itemWidth: itemWidth,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,

            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,

            modalHeight: 0,
            ddd: [
                "The min size must be a number.",
                "The min size must be less than 4.",
                "The max size must be a number."
            ]

        };

    }

    componentWillReceiveProps(propss) {

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    componentDidMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                const slideHeight = viewportHeight * 0.35;


                const sliderWidth = viewportWidth;

                container.setState({
                        widthOriginal: document.body.clientWidth,
                        widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                        //    widthV: document.body.clientWidth,
                        heightV: document.body.clientHeight,
                        // itemWidth: itemWidth,
                        sliderWidth: sliderWidth,
                        slideHeight: slideHeight,
                    },
                )


            })

    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }

    render() {
        let phone = "08633805"
        let linkUrl = "http://www.satia.me/";
        let width = "96%";
        let {widthOriginal} = this.state;
        return (
            <View style={{flex: 1}}>
                <HMActionBar back menu props={this.props} statusBarTransparent text={i18n.t('constant.About_software')}
                             headerVisibility
                             more_menu
                             drawer
                             onBackPress={() => this.props.navigation.pop()}/>
                <ScrollView style={{width: '100%'}}>
                    <View style={{
                        position: 'relative',
                        flex: 1,
                        alignItems: 'center',
                        backgroundColor: "white",
                        margin: moderateScale(8)
                    }}>

                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                backgroundColor: Colors.light43,
                                alignItems: 'center',
                                justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >
                            <HMTextView
                                text={"راهنمای وب اپلیکیشن ساتیا"}
                                // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                type={'bold'}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 4.5 : 3.5),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_header.jpeg"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >
                            <HMTextView
                                text={"وب اپلیکیشن چیست؟"}
                                // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                type={'bold'}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                            <HMTextView
                                text={" ترکیبی از وب سایت و اپلیکیشن است. وب اپلیکیشن برنامه یا نرم افزاری است که از طریق مرورگرها و اینترنت در اختیار کاربران قرار می گیرد.\n" +
                                "\n" +
                                "با ظهور وب اپلیکیشن کاربران اپلیکیشن Android و اپلیکیشن IOS دیگر محدود به اپلیکیشن های موجود در گوگل استور و اپ استور نیستند. با هر سیستم عاملی می توان فقط با وارد کردن آدرس وب اپلیکیشن در نوار جستجوی مرورگر به اپ مورد نظر دست یافت.وب اپلیکیشن فضایی از رم شما را درگیر خود نمی کند و همچنین با توجه به فناوری طراحی واکنش گرا آن ، در هر دستگاهی با همان ابعاد صفحه نمایش خود را وفق داده و به صورت استاندارد به نمایش در می آید.معمولا اپلیکیشن ها نیاز به بروز رسانی دارند اما وب اپلیکیشن همیشه در حالت آخرین نسخه خود می باشد."}
                                // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}
                                //  type={'bold'}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >
                            <HMTextView
                                text={"وب اپلیکیشن ساتیا چطور کار می کند؟"}
                                // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                type={'bold'}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                            <HMTextView
                                text={"برای استفاده از امکانات وب اپلیکیشن ساتیا ابتدا به آدرس app.satia.co مراجعه کنید.در مروگر رایانه شما در قسمت پایین صفحه ” آیا میخواهید وب اپلیکیشن ساتیا را نصب نمایید ” بر روی گزینه بله و سپس Install کلیک نمائید تا آیکون وب اپلیکیشن بر روی دسکتاپ و یا صفحه موبایل شما نمایش داده شود."}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.5 : 2.5),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                               // resizeMode={"stretch"}
                                 _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_install_web.jpeg"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"در نسخه موبایل نیز مانند نسخه دسکتاپ مراحل ذکر شده قبلی را طی می کنیم"}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_install_app.png"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"بعد از نمایش آیکون وب اپلیکیشن در دسکتاپ کامپیوتر یا صفحه نمایش موبایلتان ، می توانید از این به بعد به راحتی با کلیک بر روی آن وارد وب اپلیکیشن ساتیا شوید.\n" +
                                "\n" +
                                "برای ورود به پنل مشترکین خود ابتدا مطابق صفحه زیر شماره موبایل خود را وارد کرده و منتظر دریافت پیامک کد ورود می مانیم. پس از وارد کردن کد ورود، دکمه مرحله بعد را می زنیم."}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_entercode.jpeg"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"پس از ورود به پورتال خود می توانید در ابتدا فیلم آموزشی از راهنمای موبایل ابزار ساتیا و امکانات آن مشاهده نمائید\n"}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_video.jpeg"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"در صورت عدم تمایل به مشاهده کلیپ آموزشی می توانید از گزینه بعدا میبینم و یا پیام دیگر نمایش داده نشود استفاده نمائید.\n" +
                                "\n" +
                                "وقتی وارد پورتال خود شوید مجموعه خدمات ارائه شده را مانند تصویر زیر در وب اپلیکیشن ساتیا می بینید.مشخصات سرویس فعلی شامل روز باقیمانده، میزان گیگ بین الملل و نوع سرویس خریداری شده و هم چنین سرویس رزرو شما شامل گیگ های مازاد خریداری شده و … در این صفحه نمایش داده می شود."}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_menu.png"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>

                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                          text={"در قسمت تمدید و تغییر سرویس می توانید با توجه به بازه زمانی باقی مانده در پنل خود ، سرویس موجود را تمدید یا سرویسی جدید خریداری نمائید.\n" +
                          "* برای خرید گیگ مازاد میتوانید به راحتی بر روی دکمه خرید گیگ کلیک کرده و از بین بسته های ترافیکی موجود یکی را آنلاین خریداری نمائید.\n" +
                          "* بعد از اتمام سرویس از طریق گزینه دریافت اعتبار موقت می توانید دو روز و نیم گیگ اینترنت بین الملل دریافت نمایید که البته پس از شارژ حساب در آینده از اعتبار شما کسر خواهد شد.\n" +
                          "* در قسمت گزارش ریز مصرف می توانید با توجه به بازه زمانی انتخابی، گزارش مصرف ترافیک خود را بر اساس ترافیک مصرفی ، تخفیف و در نهایت اعتبار کسر شده ملاحظه فرمائید.در جدول گزارش نوع مصرف می توانید بر اساس نام سرویس شامل اینترنت بین الملل، سایت های داخلی، تلویزیون های اینترنتی، سایت های رایگان و پیام رسان های داخلی میزان ترافیک مصرف شده هر قسمت را ببینید.در این قسمت میتوانید نمودار مصرف ماهیانه و نوع مصرف و هم چنین گزارش ریز اتصالات را مشاهده فرمائید."}
                          style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_interntUsage.png"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"در قسمت تست SLA همانند تصویر زیر میتوانید سیگنال و نویز خط خود را مشاهده و با راهنمای قسمت توضیحات جدول مقایسه نمائید.به طور مثال می توانید گوشی تلفن خود را از مدار خارج می کنید و مجددا تست می کنید که نـویـز خط شمـا کاهش یافته یا خیر؟"}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_sla.png"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"با استفاده از گزینه تست سرعت مانند تصویر زیر می توانید سرعت اتصالتان به اینترنت ( دانلود ، آپلود ، پینگ و …) را متوجه شوید.قبل از زدن دکمه شروع تست تب های دیگر مرورگر را بسته و فایلی آپلود و دانلود نکنید و دقت داشته باشید فیلترشکنی فعال نباشد."}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_testSpeed.png"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"* در قسمت بارگزاری مدارک می توانید ، مدارک خواسته شده را به صورت عکس بارگزاری نمائید.\n" +
                                "* در قسمت سوابق سرویس ها می توانید سرویس های خریداری شده قبلی را با توجه به تاریخ و زمان و همچنین نوع خرید ملاحظه نمائید.\n" +
                                "* با استفاده از دکمه سوابق وضعیت اشتراک می توانید از تاریخ دقیق نصب و راه اندازی سرویس اینترنت خود مطلع شوید.\n" +
                                "* مجموعه پیامک های ارسالی به شما از طرف ساتیا در صندوق پیام نمایش داده میشود.\n" +
                                "* در قسمت سوابق خرید آنلاین ناموفق می توانید مجموعه خرید های انجام شده بانکی ناموفق خود را به همراه شماره پیگیری و تاریخ انجام تراکنش ملاحظه نمائید."}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_menu.png"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"\n" +
                                "*در بخش سیستم پشتیبانی می توانید مشکلات سرویس اینترنت خود را برای اپراتور پشتیبان ارسال نمائید تا در اسرع وقت با شما تماس گرفته شود.با ورود به این قسمت همانند تصویر زیر با زدن دکمه پلاس در پایین سمت راست صفحه می توانید با توجه به نوع سرویس و الویت پیام تیکت مورد نظر خود را ثبت نمائید."}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}/>
                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_addTicket.jpeg"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View
                            style={{
                                width: width,
                                height: widthOriginal / (widthOriginal > 800 ? 3.6 : 2.6),

                                marginVertical: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                // resizeMode={"stretch"}
                                _backgroundColorLoading={Colors.transparent}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={"https://app.satia.co/images/help/help_showTicket.png"}
                                //  styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                            />


                        </View>
                        <View

                            style={{
                                marginVertical: moderateScale(8),
                                width: width,

                                padding: moderateScale(8),
                                // backgroundColor: Colors.light43,
                                //  alignItems: 'center',
                                //  justifyContent: 'center',
                                //  height:moderateScale(20)
                            }}

                        >

                            <HMTextView
                                text={"* شما کاربران گرامی می توانید از قسمت معرفی به دوستان https://app.satia.co را به اشتراک گذاشته و از طریق دکمه تماس با ما نظرات و پیشنهادات خود را برای ما ارسال نمائید."}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(18),

                                }}
                                HyperlinkCheck={true}
                                linkStyle={{color: '#2980b9', fontSize: 20}}
                                onPressLink={(url, text) => alert(url + ", " + text)}
                                linkText={ url => url === 'https://app.satia.co' ? 'app.satia.co' : url }
                            />
                        </View>
                    </View>
                </ScrollView>
            </View>
        );
    }

}
